import React from "react";
import { Alert, AlertDescription, AlertTitle } from "@lemonadetraining/web-ui";
import { COMMITMENT_CHECKOUT_COPY } from "@lemonadetraining/web-shared/utils/commitmentPlans";

/* One row shape for both review panels: the same kind of fact can never end up
   described two different ways. */
export function Row({ label, value, testId }: { label: string; value: string; testId: string }) {
  return (
    <div className="flex flex-row items-baseline justify-between gap-4 py-1">
      <dt className="text-muted-foreground text-sm">{label}</dt>
      <dd className="text-right text-sm font-medium" data-testid={testId}>
        {value}
      </dd>
    </div>
  );
}

/**
 * The gym-closure disclosure, rendered from one place so the two panels cannot
 * drift: it is the same promise about the same money whatever the buyer is
 * buying, and a test asserting two copies match is weaker than one copy.
 *
 * role="note" replaces the component's default role="alert" — a standing
 * disclosure the buyer reads, not an event to interrupt them with.
 */
export function ClosureDisclosure({ testIdSuffix }: { testIdSuffix: string }) {
  return (
    <Alert role="note" className="mt-3" data-testid={`closure-disclosure-${testIdSuffix}`}>
      <AlertTitle>{COMMITMENT_CHECKOUT_COPY.closureHeading}</AlertTitle>
      <AlertDescription>{COMMITMENT_CHECKOUT_COPY.closureBody}</AlertDescription>
    </Alert>
  );
}
